import { Link } from "react-router-dom";
import NoticeShare from "./NoticeShare";

export default function NoticeCard({ notice, expanded, onToggle }) {
  const content = notice.content || "विवरण उपलब्ध छैन।";
  const hasMore = content.length > 180;

  return (
    <article
      className={`notice-card card ${notice.important ? "notice-important" : ""}`}
    >
      <div className="notice-card-top">
        <div className="notice-meta">
          <span
            className={`notice-type-badge ${notice.type === "आह्वान" ? "type-call" : "type-info"}`}
          >
            {notice.type}
          </span>
          {notice.important && (
            <span className="important-badge">महत्त्वपूर्ण</span>
          )}
          <span className="notice-date">
            {notice.date || "मिति उपलब्ध छैन"}
          </span>
        </div>
      </div>
      <h2 className="notice-title">
        <Link to={`/notices/${encodeURIComponent(notice.id)}`}>
          {notice.title || "शीर्षक उपलब्ध छैन"}
        </Link>
      </h2>
      <p className={`notice-content ${expanded ? "expanded" : ""}`}>
        {content}
      </p>
      {hasMore && (
        <button
          type="button"
          className="read-more-btn"
          onClick={() => onToggle(notice.id)}
        >
          {expanded ? "कम हेर्नुहोस्" : "थप हेर्नुहोस्"}
        </button>
      )}
      <NoticeShare notice={notice} />
    </article>
  );
}
